import { ACCOUNT_SETTINGS_ROUTES } from "@/utils/constants/accountSettingsRoutes";
import type { TopLinksRowItem } from "@/components/layout/header/TopLinksRow";
import {
  getServiceHref,
  getTopNavServices,
  IntegrationLinkKey,
} from "@/utils/constants/services/serviceCatalog";
import { sidebarItems } from "@/utils/constants/layout";
import {
  IconBuildingSkyscraper,
  IconCompass,
  IconDeviceSim,
  IconGift,
  IconHeartHandshake,
  IconInfoCircle,
  IconMapRoute,
  IconMotorbike,
  IconPlaneDeparture,
  IconPlant2,
  IconTicket,
  type Icon,
  IconBriefcase2,
  IconHeart,
  IconUserCircle,
  TablerIcon,
} from "@tabler/icons-react";

type AccountMenuItem = {
  label: string;
  href: string;
  icon: TablerIcon;
  highlighted?: boolean;
};

export const accountMenuItems: AccountMenuItem[] = [
  {
    label: "My Account",
    href: ACCOUNT_SETTINGS_ROUTES.profile,
    icon: IconUserCircle,
    highlighted: true,
  },
  {
    label: "My Trips",
    href: ACCOUNT_SETTINGS_ROUTES.trips,
    icon: IconBriefcase2,
  },
  {
    label: "Favorites",
    href: ACCOUNT_SETTINGS_ROUTES.favorites,
    icon: IconHeart,
  },
  {
    label: "My Vouchers",
    href: ACCOUNT_SETTINGS_ROUTES.vouchers,
    icon: IconTicket,
  },
];

export const mobileAccountMenuItems = accountMenuItems.filter(
  (item) => !item.highlighted,
);

//
export const TOP_NAV_ITEMS: TopLinksRowItem[] = getTopNavServices()
  .map((service) => {
    const href = getServiceHref(service);
    return href
      ? {
          href,
          label: service.label,
        }
      : null;
  })
  .filter((item): item is TopLinksRowItem => item !== null);

export type SidebarItem = {
  label: string;
  href?: string;
  integrationKey?: IntegrationLinkKey;
  matchPaths?: string[];
  disableAutoActive?: boolean;
  showSeparatorAfter?: boolean;
  tablerIcon:
    | "hotel"
    | "flight"
    | "rental"
    | "spa"
    | "tour"
    | "esim"
    | "discovery"
    | "ticketCoupon"
    | "invite"
    | "partner"
    | "about";
};

const SIDEBAR_ITEMS: SidebarItem[] = sidebarItems;
const SIDEBAR_ICONS: Record<SidebarItem["tablerIcon"], Icon> = {
  hotel: IconBuildingSkyscraper,
  flight: IconPlaneDeparture,
  rental: IconMotorbike,
  spa: IconPlant2,
  tour: IconMapRoute,
  esim: IconDeviceSim,
  discovery: IconCompass,
  ticketCoupon: IconTicket,
  invite: IconGift,
  partner: IconHeartHandshake,
  about: IconInfoCircle,
};

export { SIDEBAR_ITEMS, SIDEBAR_ICONS };
